var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f3bf65cffeae8e061fca69ec9fe9386f0543c6a7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kubera-frontend@kubera"]={id:"f3bf65cffeae8e061fca69ec9fe9386f0543c6a7"};
      